export const consultationOrderDetailCn = {
    zxzjlx:"咨询专家类型",
    zxje:"咨询金额",
    goumaiguige:'购买规格',
    zhixunyouxqzhi:'咨询有效期至'
}


// WEBPACK FOOTER //
// ./src/lang/home/consultationOrderDetail/indexCn.js